import { render, staticRenderFns } from "./MenuOrBottomSheet.vue?vue&type=template&id=4b8a66be&scoped=true"
import script from "./MenuOrBottomSheet.vue?vue&type=script&lang=js"
export * from "./MenuOrBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./MenuOrBottomSheet.vue?vue&type=style&index=0&id=4b8a66be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8a66be",
  null
  
)

export default component.exports